/* PDP BUY BOX — BUNDLE v4 (sections/pdp-buybox-bundle-v4.liquid). Built 2026-10-07.
   Deferred asset, no inline Liquid in this file, never formats money (all price strings
   come from Liquid).

   Data islands
   - [data-bbv4-variants]   [{id, available, o[], media, price, compare, savePct, per,
                              worth, fs, c: [[componentVariantId, qty], ...]}]
   - [data-bbv4-components] {componentVariantId: {t, l, img, p, hm, hero, heroAlt, inc[]}}
   - [data-bbv4-config]     {mode, optionValues, explicitVariantId, sizeIdx, preSize,
                              rows: [[choiceVariantId, ...], ...], deoTotal, texts...}

   Resolving the shopper's choice to ONE bundle variant
   - mode 'components': size option INDEX + the multiset of chosen row variants + the deo
     counts is matched against each variant's real components (only component ids that are
     choices count). Order-insensitive, so 3 rows Amber/Frosted map to the 4 count variants
     whatever row holds which colour, and a wrong option order in the catalog can never put
     the wrong bundle in the cart.
   - mode 'options': option-value INDEX tuple (fallback when component data is missing).

   Add to cart: the bundle first, then each ticked add-on (assets/elico-atc-crosssell.js)
   in its own call, so a sold-out add-on never blocks the bundle. */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function parse(el) {
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { console.warn('[pdp-bbv4] bad data island', e); return null; }
  }

  function init(root) {
    var VARIANTS = parse(root.querySelector('[data-bbv4-variants]'));
    var CFG = parse(root.querySelector('[data-bbv4-config]'));
    var COMP = parse(root.querySelector('[data-bbv4-components]')) || {};
    if (!VARIANTS || !CFG) return;

    var MODE = CFG.mode === 'components' ? 'components' : (CFG.mode === 'counter' ? 'counter' : 'options');
    var CTR_TOTAL = MODE === 'counter' ? (CFG.counterTotal || 0) : 0;
    var BP = CFG.desktopBreakpoint || 990;
    var SIZE = typeof CFG.sizeIdx === 'number' ? CFG.sizeIdx : -1;
    var ROWS = CFG.rows || [];
    var DEO_TOTAL = CFG.deoTotal || 0;
    var OPT_N = (CFG.optionValues || []).length;

    function all(sel) { return root.querySelectorAll(sel); }

    // deo scent variant ids, in display order (from the rendered picker)
    var DEO = [];
    var DEO_STOCK = [];
    all('[data-bbv4-scent]').forEach(function (el) {
      DEO.push(parseInt(el.getAttribute('data-vid'), 10));
      DEO_STOCK.push(el.getAttribute('data-instock') === '1');
    });
    if (!DEO.length) DEO_TOTAL = 0;

    // every component id that is a CHOICE (rows + deo); fixed components are ignored in matching
    var ROW_IDS = {}, DEO_IDS = {};
    ROWS.forEach(function (r) { r.forEach(function (id) { ROW_IDS[id] = true; }); });
    DEO.forEach(function (id) { DEO_IDS[id] = true; });

    function sig(map) {
      return Object.keys(map).filter(function (k) { return map[k] > 0; }).sort().map(function (k) { return k + ':' + map[k]; }).join(',');
    }

    // ── per-variant index data ─────────────────────────────────────────
    var MAP = {};
    VARIANTS.forEach(function (v) {
      v.i = (v.o || []).map(function (val, k) { return (CFG.optionValues[k] || []).indexOf(val); });
      v.size = SIZE >= 0 ? v.i[SIZE] : 0;
      if (MODE === 'counter') {
        v.key = 'a' + v.ac;
      } else if (MODE === 'components') {
        var rm = {}, dm = {};
        (v.c || []).forEach(function (p) {
          if (ROW_IDS[p[0]]) rm[p[0]] = (rm[p[0]] || 0) + p[1];
          if (DEO_IDS[p[0]]) dm[p[0]] = (dm[p[0]] || 0) + p[1];
        });
        v.rowSig = sig(rm);
        v.deoCounts = DEO.map(function (id) { return dm[id] || 0; });
        v.key = v.size + '|' + v.rowSig + '|' + v.deoCounts.join(',');
      } else {
        v.key = v.i.join('|');
      }
      if (!MAP[v.key]) MAP[v.key] = v;
    });
    function byId(id) {
      for (var k = 0; k < VARIANTS.length; k++) if (VARIANTS[k].id === id) return VARIANTS[k];
      return null;
    }

    // ── state ────────────────────────────────────────────────────────────
    var st = { size: 0, rows: ROWS.map(function (r) { return r[0]; }), counts: DEO.map(function () { return 0; }), opts: [] };

    function rowSigOf(rows) {
      var m = {};
      rows.forEach(function (id) { if (id) m[id] = (m[id] || 0) + 1; });
      return sig(m);
    }
    function total() { return st.counts.reduce(function (a, b) { return a + b; }, 0); }
    function keyFor(size, rows, counts) { return size + '|' + rowSigOf(rows) + '|' + counts.join(','); }

    function currentVariant() {
      if (MODE === 'counter') return MAP['a' + st.amber] || null;
      if (MODE === 'components') {
        if (DEO_TOTAL && total() !== DEO_TOTAL) return null;
        return MAP[keyFor(st.size, st.rows, st.counts)] || null;
      }
      var idx = [];
      for (var k = 0; k < OPT_N; k++) idx.push(k === SIZE ? st.size : (st.opts[k] || 0));
      return MAP[idx.join('|')] || null;
    }

    // candidates sharing the current size + rows (components mode), any deo split
    function siblings(size) {
      var rs = rowSigOf(st.rows);
      return VARIANTS.filter(function (v) { return v.size === size && v.rowSig === rs; });
    }
    function scentSoldOut(s) {
      if (DEO_STOCK[s] === false) return true;
      return !siblings(st.size).some(function (v) { return v.available && v.deoCounts[s] > 0; });
    }
    // the most even available deo split for a size (used for the preview price and seeding)
    function balanced(size) {
      var best = null, bestMax = 1e9;
      siblings(size).forEach(function (v) {
        if (!v.available) return;
        var bad = v.deoCounts.some(function (n, s) { return n > 0 && DEO_STOCK[s] === false; });
        if (bad) return;
        var m = Math.max.apply(null, v.deoCounts.concat([0]));
        if (m < bestMax) { bestMax = m; best = v; }
      });
      return best || siblings(size)[0] || null;
    }

    // seed the UI from a variant (rows get the variant's chosen ids in row order)
    function seedFrom(v) {
      if (!v) return;
      if (MODE === 'counter') { st.amber = v.ac; return; }
      if (SIZE >= 0 && v.i[SIZE] >= 0) st.size = v.i[SIZE];
      if (MODE === 'components') {
        var left = {};
        (v.c || []).forEach(function (p) { if (ROW_IDS[p[0]]) left[p[0]] = (left[p[0]] || 0) + p[1]; });
        st.rows = ROWS.map(function (choices) {
          for (var k = 0; k < choices.length; k++) {
            if (left[choices[k]] > 0) { left[choices[k]] -= 1; return choices[k]; }
          }
          return choices[0];
        });
        st.counts = (v.deoCounts || []).slice();
      } else {
        st.opts = v.i.slice();
      }
    }
    (function seed() {
      var ex = CFG.explicitVariantId ? byId(CFG.explicitVariantId) : null;
      if (MODE === 'counter') { st.amber = ctrSeed(ex); return; }
      if (ex) { seedFrom(ex); return; }
      var size = (SIZE >= 0 && CFG.preSize >= 0) ? CFG.preSize : 0;
      var pool = VARIANTS.filter(function (v) { return SIZE < 0 || v.size === size; });
      var pick = null;
      if (MODE === 'components' && DEO.length) {
        // first available row combination for this size, then the most even deo split
        var first = pool.filter(function (v) { return v.available; })[0] || pool[0];
        if (first) { seedFrom(first); st.size = size; pick = balanced(size); }
      } else {
        pick = pool.filter(function (v) { return v.available; })[0] || pool[0];
      }
      seedFrom(pick || VARIANTS[0]);
      if (SIZE >= 0) st.size = size;
    })();

    function setSel(btns, on) {
      btns.forEach(function (b) {
        var o = on(b);
        b.classList.toggle('is-selected', o);
        b.setAttribute('aria-pressed', o ? 'true' : 'false');
      });
    }

    // ── render ───────────────────────────────────────────────────────────
    var atcBtn = root.querySelector('[data-bbv4-atc]');
    var stickyBtn = root.querySelector('[data-bbv4-sticky-atc]');
    var msgEl = root.querySelector('[data-bbv4-msg]');
    var adding = false;
    var lastVariantId = null;

    function showMsg(t) { if (msgEl) msgEl.textContent = t || ''; }

    // the variant a size tile previews: same rows + deo, else the balanced one
    function previewFor(size) {
      if (MODE === 'components') {
        return MAP[keyFor(size, st.rows, st.counts)] || balanced(size);
      }
      var idx = [];
      for (var k = 0; k < OPT_N; k++) idx.push(k === SIZE ? size : (st.opts[k] || 0));
      return MAP[idx.join('|')] || null;
    }
    function pieces(v) {
      return v ? (v.c || []).reduce(function (a, p) { return a + p[1]; }, 0) : 0;
    }
    function itemsText(n) {
      return n === 1 ? CFG.itemsOne : String(CFG.itemsOther || '').replace('9999', String(n));
    }

    function render() {
      var v = currentVariant();
      var shown = v || (MODE === 'components' ? balanced(st.size) : null);
      var ok = !!(v && v.available);
      if (ok && MODE === 'components') {
        for (var s0 = 0; s0 < DEO.length; s0++) if (st.counts[s0] > 0 && DEO_STOCK[s0] === false) ok = false;
      }

      // size tiles
      setSel(all('[data-bbv4-size]'), function (b) { return parseInt(b.getAttribute('data-bbv4-size'), 10) === st.size; });
      all('[data-bbv4-size]').forEach(function (b) {
        var s = parseInt(b.getAttribute('data-bbv4-size'), 10);
        var sv = previewFor(s);
        var pEl = root.querySelector('[data-bbv4-size-price="' + s + '"]');
        var wEl = root.querySelector('[data-bbv4-size-worth="' + s + '"]');
        var dEl = root.querySelector('[data-bbv4-size-desc="' + s + '"]');
        var fEl = root.querySelector('[data-bbv4-size-fs="' + s + '"]');
        var rEl = root.querySelector('[data-bbv4-size-per="' + s + '"]');
        if (rEl) { rEl.textContent = sv && sv.per ? sv.per : ''; rEl.hidden = !(sv && sv.per); }
        if (pEl) pEl.textContent = sv ? sv.price : '';
        if (wEl) { wEl.textContent = sv && sv.compare ? sv.compare : ''; wEl.style.display = sv && sv.compare ? '' : 'none'; }
        if (dEl) { var n = pieces(sv); dEl.textContent = n ? itemsText(n) : ''; }
        if (fEl) fEl.hidden = !(sv && sv.fs);
      });

      if (MODE === 'components') {
        // swatch rows
        all('[data-bbv4-row]').forEach(function (b) {
          var r = parseInt(b.getAttribute('data-bbv4-row'), 10);
          var on = parseInt(b.getAttribute('data-vid'), 10) === st.rows[r];
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        all('[data-bbv4-row]').forEach(function (b) {
          var r = parseInt(b.getAttribute('data-bbv4-row'), 10);
          var alt = st.rows.slice(); alt[r] = parseInt(b.getAttribute('data-vid'), 10);
          var rs = rowSigOf(alt);
          var any = VARIANTS.some(function (x) { return x.available && x.size === st.size && x.rowSig === rs; });
          b.classList.toggle('is-soldout', !any);
          var so2 = b.querySelector('[data-bbv4-swatch-so]'); if (so2) so2.hidden = any;
          var lbl = b.getAttribute('data-label') || '';
          b.setAttribute('aria-label', any ? lbl : lbl + ' (' + (CFG.soldOutText || '') + ')');
        });
        ROWS.forEach(function (_, r) {
          var cur = root.querySelector('[data-bbv4-row="' + r + '"].is-selected');
          var out = root.querySelector('[data-bbv4-row-current="' + r + '"]');
          if (out) out.textContent = cur ? (cur.getAttribute('data-label') || '') : '';
        });
        // deo picker
        var tot = total();
        all('[data-bbv4-scent]').forEach(function (item) {
          var s = parseInt(item.getAttribute('data-bbv4-scent'), 10);
          var out = scentSoldOut(s);
          var q = st.counts[s] || 0;
          if (item.hasAttribute('data-bbv4-deo-single')) {
            // deo.total == 1: single-select tile (selected = the one scent counted)
            item.classList.toggle('is-selected', q > 0);
            item.classList.toggle('is-soldout', out);
            item.setAttribute('aria-pressed', q > 0 ? 'true' : 'false');
            item.disabled = out && q === 0;
            var so1 = item.querySelector('[data-bbv4-swatch-so]'); if (so1) so1.hidden = !out;
            var lbl = item.getAttribute('data-label') || '';
            item.setAttribute('aria-label', out ? lbl + ' (' + (CFG.soldOutText || '') + ')' : lbl);
            return;
          }
          item.classList.toggle('is-soldout', out);
          item.classList.toggle('is-active', q > 0);
          var so = item.querySelector('[data-bbv4-soldout]'); if (so) so.hidden = !out;
          item.querySelector('[data-bbv4-qty]').textContent = String(q);
          item.querySelector('[data-bbv4-dec]').disabled = q <= 0;
          item.querySelector('[data-bbv4-inc]').disabled = out || tot >= DEO_TOTAL;
          var add = item.querySelector('[data-bbv4-add]'); if (add) add.disabled = out || tot >= DEO_TOTAL;
        });
        var bar = root.querySelector('[data-bbv4-deo-bar]');
        if (bar) bar.style.width = (DEO_TOTAL ? Math.min(100, tot / DEO_TOTAL * 100) : 0) + '%';
        var hint = root.querySelector('.b3deo__hint');
        if (hint && CFG.deoLeftTpl) hint.textContent = tot < DEO_TOTAL ? CFG.deoLeftTpl.replace('__L__', String(DEO_TOTAL - tot)) : (CFG.deoReadyText || '');
        var dcur = root.querySelector('[data-bbv4-deo-current]');
        if (dcur) {
          var dsel = root.querySelector('[data-bbv4-deo-single].is-selected');
          dcur.textContent = dsel ? (dsel.getAttribute('data-label') || '') : '';
        }
        var counter = root.querySelector('[data-bbv4-deo-counter]');
        if (counter) counter.textContent = (CFG.counterTpl || '').replace('__C__', String(tot)).replace('__T__', String(DEO_TOTAL));
      } else {
        all('[data-bbv4-opt]').forEach(function (b) {
          var k = parseInt(b.getAttribute('data-bbv4-opt'), 10);
          var val = parseInt(b.getAttribute('data-val'), 10);
          var on = (st.opts[k] || 0) === val;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          // mark (never block) a value whose variant for the other current choices is sold out
          var idx = [];
          for (var j = 0; j < OPT_N; j++) idx.push(j === k ? val : (j === SIZE ? st.size : (st.opts[j] || 0)));
          var cand = MAP[idx.join('|')];
          b.classList.toggle('is-soldout', !cand || !cand.available);
        });
        all('[data-bbv4-opt-current]').forEach(function (out) {
          var k = out.getAttribute('data-bbv4-opt-current');
          var cur = root.querySelector('[data-bbv4-opt="' + k + '"].is-selected');
          out.textContent = cur ? (cur.getAttribute('data-label') || '') : '';
        });
      }

      if (MODE === 'counter') renderCounter();

      // price line + free shipping
      if (shown) {
        all('[data-bbv4-price]').forEach(function (el) { el.textContent = shown.price; });
        all('[data-bbv4-compare]').forEach(function (el) {
          if (shown.compare) { el.textContent = shown.compare; el.style.display = ''; } else { el.style.display = 'none'; }
        });
        all('[data-bbv4-save-pct]').forEach(function (el) {
          if (shown.savePct) { el.textContent = shown.savePct; el.style.display = ''; } else { el.style.display = 'none'; }
        });
      }
      var fsEl = root.querySelector('[data-bbv4-fs]');
      if (fsEl) fsEl.hidden = !(shown && shown.fs);
      var badges = root.querySelector('[data-bbv4-badges]');
      if (badges) {
        var pctEl = badges.querySelector('[data-bbv4-save-pct]');
        var pctOn = !!(pctEl && pctEl.style.display !== 'none');
        badges.classList.toggle('is-empty', !pctOn && !(fsEl && !fsEl.hidden));
      }

      // ATC state
      var incomplete = MODE === 'components' && DEO_TOTAL && total() !== DEO_TOTAL;
      all('[data-atc-label]').forEach(function (el) {
        // same label logic as the Liquid button: pre-order variants keep the pre-order label
        el.textContent = incomplete ? CFG.incompleteText : (ok ? ((v && v.pre && CFG.preorderText) ? CFG.preorderText : CFG.atcText) : CFG.unavailableText);
      });
      [atcBtn, stickyBtn].forEach(function (b) {
        if (!b) return;
        if (ok && !adding) b.removeAttribute('disabled'); else b.setAttribute('disabled', 'disabled');
      });

      renderContents(shown);

      if (v) {
        var vid = root.querySelector('[data-variant-id]');
        if (vid) vid.value = String(v.id);
        if (lastVariantId !== v.id) {
          var firstRender = lastVariantId === null;
          lastVariantId = v.id;
          if (!firstRender && window.history && window.history.replaceState) {
            try { var u = new URL(window.location.href); u.searchParams.set('variant', String(v.id)); window.history.replaceState({}, '', u.toString()); } catch (e) { }
          }
          root.dispatchEvent(new CustomEvent('elico:variant-change', { bubbles: true, detail: { variantId: v.id, sectionId: root.getAttribute('data-section-id') } }));
          document.dispatchEvent(new CustomEvent('elico:variant', { detail: { sectionId: root.getAttribute('data-section-id'), variantId: v.id } }));
        }
      }
    }

    // ── "Dette får du": the shown variant's real components, in metafield order ──
    function renderContents(v) {
      var box = root.querySelector('[data-bbv4-contents]');
      var list = root.querySelector('[data-bbv4-contents-list]');
      if (!box || !list) return;
      var parts = v && v.c ? v.c : [];
      if (!parts.length) { box.hidden = true; return; }
      box.hidden = false;
      var html = '', n = 0;
      parts.forEach(function (p) {
        var c = COMP[String(p[0])];
        if (!c) return;
        n += p[1];
        var name = p[1] + ' × ' + c.t + (c.l ? ' / ' + c.l : '');
        var inc = (c.inc || []).filter(function (x) { return x; });
        html += '<li class="b3inc__item"><span class="b3inc__media">' + (c.img ? '<img class="b3inc__img" loading="lazy" alt="" src="' + esc(c.img) + '">' : '') + '</span>' +
          '<span class="b3inc__body"><span class="b3inc__name">' + esc(name) + '</span>' +
          (inc.length ? '<ul class="b3inc__incl">' + inc.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>' : '') +
          '</span></li>';
      });
      list.innerHTML = html;
      var cnt = root.querySelector('[data-bbv4-contents-count]');
      if (cnt) cnt.textContent = n ? itemsText(n) : '';
    }

    // ── interactions ─────────────────────────────────────────────────────
    // component variant slots in the gallery (e.g. the Frosted kit image when Frosted is chosen)
    function syncCompSlots(v) {
      if (!v || !v.c) return;
      all('[data-bbv4-comp-slot]').forEach(function (slide) {
        var pid = slide.getAttribute('data-bbv4-comp-slot');
        var hit = null;
        v.c.forEach(function (pair) { var m = COMP[pair[0]]; if (m && String(m.p) === pid && m.hero && !hit) hit = m; });
        if (!hit || slide.getAttribute('data-media-id') === String(hit.hm)) return;
        slide.setAttribute('data-media-id', String(hit.hm));
        var img = slide.querySelector('img');
        if (img) { img.removeAttribute('srcset'); img.src = hit.hero; img.alt = hit.heroAlt || ''; }
        var th = root.querySelector('[data-bbv4-comp-thumb="' + pid + '"] img');
        if (th) { th.removeAttribute('srcset'); th.src = String(hit.hero).replace(/width=\d+/, 'width=160'); }
      });
    }
    function changed() {
      showMsg('');
      render();
      syncCompSlots(currentVariant());
      var v = currentVariant();
      if (v && v.media) showVariantMedia(v.media);
    }
    // [ELICO 2026-10-08] The hero follows the selected variant (e.g. Bathroom Pack Standard vs
    // Large): when the variant's own image is not the first slide, swap it with the first slide
    // (slide content + data-media-id, and the matching thumbnails), then show slide 0. Indices
    // stay the same, so the thumb click handlers bound by index keep working. Component slots
    // (data-bbv4-comp-slot) are never swapped; for those we only scroll, as before.
    function swapChildren(a, b) {
      if (!a || !b || a === b) return;
      var tmp = document.createDocumentFragment();
      while (a.firstChild) tmp.appendChild(a.firstChild);
      while (b.firstChild) a.appendChild(b.firstChild);
      b.appendChild(tmp);
    }
    function showVariantMedia(mediaId) {
      var slides = all('[data-bbv4-slide]');
      var j = -1;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(mediaId)) { j = i; break; }
      }
      if (j <= 0 || slides[0].hasAttribute('data-bbv4-comp-slot') || slides[j].hasAttribute('data-bbv4-comp-slot')) {
        goToMedia(mediaId);
        return;
      }
      swapChildren(slides[0], slides[j]);
      var firstId = slides[0].getAttribute('data-media-id');
      slides[0].setAttribute('data-media-id', String(mediaId));
      slides[j].setAttribute('data-media-id', firstId);
      ['[data-bbv4-thumb]', '[data-bbv4-rail-thumb]'].forEach(function (sel) {
        var th = all(sel);
        if (th[0] && th[j]) swapChildren(th[0], th[j]);
      });
      go(0);
    }
    all('[data-bbv4-size]').forEach(function (b) {
      b.addEventListener('click', function () { st.size = parseInt(b.getAttribute('data-bbv4-size'), 10); changed(); });
    });
    all('[data-bbv4-row]').forEach(function (b) {
      b.addEventListener('click', function () {
        st.rows[parseInt(b.getAttribute('data-bbv4-row'), 10)] = parseInt(b.getAttribute('data-vid'), 10);
        changed();
      });
    });
    all('[data-bbv4-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        st.opts[parseInt(b.getAttribute('data-bbv4-opt'), 10)] = parseInt(b.getAttribute('data-val'), 10);
        changed();
      });
    });
    all('[data-bbv4-scent]').forEach(function (item) {
      var s = parseInt(item.getAttribute('data-bbv4-scent'), 10);
      if (item.hasAttribute('data-bbv4-deo-single')) {
        item.addEventListener('click', function () {
          if (scentSoldOut(s) || st.counts[s] > 0) return;
          st.counts = DEO.map(function (_, k) { return k === s ? 1 : 0; });
          changed();
        });
        return;
      }
      var addBtn = item.querySelector('[data-bbv4-add]');
      if (addBtn) addBtn.addEventListener('click', function () {
        if (total() >= DEO_TOTAL || scentSoldOut(s)) return;
        st.counts[s] += 1; changed();
        var inc = item.querySelector('[data-bbv4-inc]'); if (inc && !inc.disabled) inc.focus(); else { var dec = item.querySelector('[data-bbv4-dec]'); if (dec) dec.focus(); }
      });
      item.querySelector('[data-bbv4-inc]').addEventListener('click', function () {
        if (total() >= DEO_TOTAL || scentSoldOut(s)) return;
        st.counts[s] += 1; changed();
      });
      item.querySelector('[data-bbv4-dec]').addEventListener('click', function () {
        if (st.counts[s] <= 0) return;
        st.counts[s] -= 1; changed();
        // the stepper hides at 0: keep keyboard focus on the tile's "add" button
        if (st.counts[s] === 0) { var a = item.querySelector('[data-bbv4-add]'); if (a) a.focus(); }
      });
    });

    // ── counter mode (Gavepakke) [ELICO 2026-10-31] ─────────────────────
    // Two steppers (Amber, Frosted) that always sum to CTR_TOTAL: one more Frosted = one less Amber and
    // vice versa. st.amber selects the variant whose pdp.amber_count equals it (data island "ac"); a step
    // that would land on a missing or sold-out variant is disabled. Function declarations: hoisted, so
    // seed() above can use ctrSeed().
    function ctrAvailable(a) {
      var x = (a >= 0 && a <= CTR_TOTAL) ? MAP['a' + a] : null;
      return !!(x && x.available);
    }
    function ctrSeed(ex) {
      if (ex && ex.available) return ex.ac;
      var want = ex ? ex.ac : (typeof CFG.counterDefault === 'number' ? CFG.counterDefault : 0);
      for (var d = 0; d <= CTR_TOTAL; d++) {
        if (ctrAvailable(want + d)) return want + d;
        if (ctrAvailable(want - d)) return want - d;
      }
      return Math.max(0, Math.min(CTR_TOTAL, want));
    }
    var ctrTouched = false;
    function renderCounter() {
      var box = root.querySelector('[data-bbv4-counter]');
      if (!box) return;
      var a = st.amber, f = CTR_TOTAL - a, labels = {};
      all('[data-bbv4-ctr-card]').forEach(function (card) {
        var kind = card.getAttribute('data-bbv4-ctr-card');
        var n = kind === 'amber' ? a : f;
        labels[kind] = card.getAttribute('data-label') || '';
        card.classList.toggle('is-active', n > 0);
        var q = card.querySelector('[data-bbv4-ctr-qty]');
        if (q) q.textContent = String(n);
        [['inc', 1], ['dec', -1]].forEach(function (p) {
          var b = card.querySelector('[data-bbv4-ctr-' + p[0] + ']');
          if (!b) return;
          var next = a + (kind === 'amber' ? p[1] : -p[1]);
          var inRange = next >= 0 && next <= CTR_TOTAL;
          var ok = inRange && ctrAvailable(next);
          b.disabled = !ok;
          if (!b.hasAttribute('data-aria')) b.setAttribute('data-aria', b.getAttribute('aria-label') || '');
          var base = b.getAttribute('data-aria');
          b.setAttribute('aria-label', (inRange && !ok) ? base + ' (' + (CFG.soldOutText || '') + ')' : base);
        });
      });
      // sold-out note: every mix that can't be picked right now, in the theme's own sold-out word
      var so = box.querySelector('[data-bbv4-ctr-so]');
      if (so) {
        var out = VARIANTS.filter(function (x) { return !x.available; }).map(function (x) { return (x.o || []).join(' / '); });
        so.textContent = out.length ? out.join(', ') + ': ' + (CFG.soldOutText || '') : '';
        so.hidden = !out.length;
      }
      // live region: announce the new mix only after the shopper changed it (not on page load)
      var stEl = box.querySelector('[data-bbv4-ctr-status]');
      if (stEl && ctrTouched) stEl.textContent = a + ' ' + (labels.amber || '') + ', ' + f + ' ' + (labels.frosted || '');
      // [ELICO 2026-11-01] GIFT5 REDESIGN: the sticky button shows the chosen mix ("3 Amber · 2 Frosted")
      var mixTxt = [[a, labels.amber], [f, labels.frosted]].filter(function (p) { return p[0] > 0; })
        .map(function (p) { return p[0] + ' ' + (p[1] || ''); }).join(' \u00b7 ');
      all('[data-bbv4-sticky-mix], [data-bbv4-inc-mix]').forEach(function (el) { el.textContent = mixTxt; });
    }
    function ctrStep(btn, kind, dir) {
      var next = st.amber + (kind === 'amber' ? dir : -dir);
      if (!ctrAvailable(next)) return;
      st.amber = next;
      ctrTouched = true;
      changed();
      // a step that just hit its limit is disabled: keep keyboard focus inside the same card
      if (btn.disabled) {
        var other = btn.parentNode && btn.parentNode.querySelector('.b4ctr__btn:not([disabled])');
        if (other) other.focus();
      }
    }
    all('[data-bbv4-ctr-inc]').forEach(function (b) {
      b.addEventListener('click', function () { ctrStep(b, b.getAttribute('data-bbv4-ctr-inc'), 1); });
    });
    all('[data-bbv4-ctr-dec]').forEach(function (b) {
      b.addEventListener('click', function () { ctrStep(b, b.getAttribute('data-bbv4-ctr-dec'), -1); });
    });

    // ── add to cart: bundle line first, then each ticked add-on ─────────
    var routes = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    function post(items, withDrawer) {
      var body = { items: items };
      // [ELICO 2026-10-08] ask for the drawer section in the same response, so the drawer can
      // open on the new lines without a second request (see openCartDrawer)
      if (withDrawer) body.sections = 'api-cart-items';
      return fetch(routes + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); });
    }
    function addToCart() {
      var v = currentVariant();
      if (!v || !v.available || adding) return;
      adding = true;
      showMsg('');
      render();
      var XS = window.ElicoAtcCrossSell;
      var bundleSections = null;
      post([{ id: v.id, quantity: 1 }], true).then(function (res) {
        if (!res.ok) throw { bundle: true, d: res.d };
        bundleSections = (res.d && res.d.sections) || null;
        if (!XS || !XS.selected(root).length) return null;
        // add-ons go in AFTER the bundle, one call each (snippets/elico-atc-crosssell.liquid)
        return XS.addSelected(root).then(function (r) {
          if (r.failed) return 'addon-failed';
          return 'addons';
        }, function () { return 'addon-failed'; });
      }).then(function (state) {
        adding = false;
        render();
        if (state === 'addon-failed') {
          // the bundle IS in the cart: keep the add-on message visible and refresh the drawer
          // contents and header count without opening it
          showMsg(CFG.tinFailedText);
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        } else {
          // add-ons changed the cart after the bundle response, so re-read the section then
          openCartDrawer(state === 'addons' ? null : bundleSections);
        }
      }).catch(function (err) {
        adding = false;
        render();
        console.warn('[pdp-bbv4] add to cart failed', err);
        showMsg((err && err.d && err.d.description) || CFG.addFailedText);
      });
    }
    function openCartDrawer(sections) {
      // [ELICO 2026-10-08] No fixed delay: open the cart drawer as soon as the add resolved, with its
      // lines already rebuilt. Uses the `sections` HTML returned by /cart/add.js when the caller asked
      // for it (zero extra requests), else one GET of the same section. Never opens on stale lines.
      var drawer = document.querySelector('cart-element#cart-drawer, cart-element, [data-cart-drawer]');
      if (!drawer || typeof drawer.getCart !== 'function') { window.location.href = routes + 'cart'; return; }
      function show() {
        try {
          if (typeof drawer.openCartDrawer === 'function') drawer.openCartDrawer();
          else if (typeof drawer.open === 'function') drawer.open();
        } catch (e) { window.location.href = routes + 'cart'; }
      }
      function apply(html) {
        try {
          if (!drawer.isCartDrawerLoaded && typeof drawer.renderCartDrawer === 'function') drawer.renderCartDrawer(false);
          var box = document.createElement('div');
          box.innerHTML = html || '';
          var content = box.querySelector('[data-api-content]');
          if (content && typeof drawer.build === 'function') { drawer.build(content); return true; }
        } catch (e) {}
        return false;
      }
      if (sections && apply(sections['api-cart-items'])) { show(); return; }
      fetch(routes + 'cart?section_id=api-cart-items').then(function (r) { return r.text(); }).then(function (t) {
        if (!apply(t)) { try { drawer.getCart(); } catch (e) {} }
        show();
      }, function () { try { drawer.getCart(); } catch (e) {} show(); });
    }
    if (atcBtn) atcBtn.addEventListener('click', addToCart);
    if (stickyBtn) stickyBtn.addEventListener('click', addToCart);

    // ── sticky ATC ───────────────────────────────────────────────────────
    var sticky = root.querySelector('[data-bbv4-sticky]');
    var atcWrap = root.querySelector('[data-bbv4-atc-wrap]');
    if (sticky && atcWrap && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        sticky.classList.toggle('is-hidden', e.isIntersecting);
      }, { threshold: 0, rootMargin: root.hasAttribute('data-g5') ? '-70px 0px 0px 0px' : '0px' }).observe(atcWrap); // [ELICO 2026-11-01] GIFT5 REDESIGN: a button under the header counts as off screen
    }

    // ── gallery ──────────────────────────────────────────────────────────
    var hero = root.querySelector('[data-bbv4-hero]');
    var wrap = root.querySelector('[data-bbv4-hero-wrap]');
    // desktop layout (vertical snap column) starts at the same breakpoint as the section CSS
    var mqDesk = window.matchMedia ? window.matchMedia('(min-width: ' + BP + 'px)') : null;
    function vertical() { return !!hero && !!(mqDesk && mqDesk.matches) && !root.hasAttribute('data-g5'); } // [ELICO 2026-11-01] GIFT5 REDESIGN: gift page slides sideways on desktop too
    // [ELICO 2026-10-09] Only nudge the thumb strip when the active thumb is out of view.
    // Before, every tap/scroll tick snapped the strip so the active thumb sat at the left edge,
    // which made the carousel jump and look laggy on mobile.
    function keepInView(tr, t, vert) {
      var a = t.getBoundingClientRect(), b = tr.getBoundingClientRect(), pad = 12;
      if (vert) {
        if (a.top < b.top) tr.scrollTop += a.top - b.top - pad;
        else if (a.bottom > b.bottom) tr.scrollTop += a.bottom - b.bottom + pad;
      } else {
        if (a.left < b.left) tr.scrollLeft += a.left - b.left - pad;
        else if (a.right > b.right) tr.scrollLeft += a.right - b.right + pad;
      }
    }
    function setActive(i) {
      all('[data-bbv4-thumb]').forEach(function (t, x) {
        t.classList.toggle('is-active', x === i);
        if (x === i) {
          t.setAttribute('aria-current', 'true');
          var tr = t.parentNode;
          if (tr) keepInView(tr, t, vertical());
        }
        else t.removeAttribute('aria-current');
      });
      all('[data-bbv4-rail-thumb]').forEach(function (t, x) { t.classList.toggle('is-active', x === i); });
    }
    function go(i) {
      var slides = all('[data-bbv4-slide]');
      if (!slides[i]) return;
      // phones: horizontal swipe; desktop (Estrid pattern): vertical scroll-snap column
      if (!hero) { setActive(i); return; }
      if (vertical()) hero.scrollTo({ top: slides[i].offsetTop, behavior: 'smooth' });
      else hero.scrollTo({ left: hero.clientWidth * i, behavior: 'smooth' });
      setActive(i);
    }
    function goToMedia(mediaId) {
      var slides = all('[data-bbv4-slide]');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-id') === String(mediaId)) { go(i); return; }
      }
    }
    all('[data-bbv4-thumb]').forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    all('[data-bbv4-rail-thumb]').forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
    function syncFromScroll() {
      var slides = all('[data-bbv4-slide]');
      if (!slides.length) return;
      var i;
      if (hero) i = vertical() ? Math.round(hero.scrollTop / (hero.clientHeight || 1)) : Math.round(hero.scrollLeft / (hero.clientWidth || 1));
      if (i >= 0 && i < slides.length) setActive(i);
    }
    if (hero) hero.addEventListener('scroll', syncFromScroll, { passive: true });
    if (wrap) wrap.addEventListener('scroll', syncFromScroll, { passive: true });

    // ── contents <details>: collapsed by default on every width, the shopper opens it with
    // the "Vis innholdet" toggle (native <details>; the old desktop CSS hid the toggle and
    // the JS forced the open state on resize, which made it unusable on desktop) ─────────
    var contents = root.querySelector('[data-bbv4-contents]');
    if (contents) {
      var toggle = contents.querySelector('[data-bbv4-contents-toggle]');
      var syncToggle = function () {
        if (!toggle) return;
        toggle.textContent = contents.open ? (toggle.getAttribute('data-open-text') || '') : (toggle.getAttribute('data-closed-text') || '');
      };
      contents.addEventListener('toggle', syncToggle);
      syncToggle();
    }

    // ── ingredients drawer (same slide-out pattern as the hand soap starter kit page) ──
    var ingDrawer = root.querySelector('[data-bbv4-ing-drawer]');
    var ingOpener = null, ingTimer = null, prevOverflow = '';
    function ingKey(e) {
      if (e.key === 'Escape') { closeIng(); return; }
      if (e.key !== 'Tab') return;
      var f = ingDrawer.querySelectorAll('button, summary, [href], [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      var panel = ingDrawer.querySelector('.ebb__drawer-panel');
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }
    function openIng(e) {
      if (!ingDrawer) return;
      ingOpener = e && e.currentTarget;
      if (ingTimer) { clearTimeout(ingTimer); ingTimer = null; }
      if (ingDrawer.hidden) prevOverflow = document.documentElement.style.overflow;
      ingDrawer.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      window.requestAnimationFrame(function () { ingDrawer.classList.add('is-open'); });
      var panel = ingDrawer.querySelector('.ebb__drawer-panel'); if (panel) panel.focus();
      document.addEventListener('keydown', ingKey);
    }
    function closeIng() {
      if (!ingDrawer || ingDrawer.hidden || !ingDrawer.classList.contains('is-open')) return;
      ingDrawer.classList.remove('is-open');
      document.removeEventListener('keydown', ingKey);
      document.documentElement.style.overflow = prevOverflow;
      ingTimer = setTimeout(function () { ingDrawer.hidden = true; ingTimer = null; }, 300);
      if (ingOpener) ingOpener.focus();
    }
    if (ingDrawer) {
      root.querySelectorAll('[data-bbv4-ing-open]').forEach(function (b) { b.addEventListener('click', openIng); });
      ingDrawer.querySelectorAll('[data-bbv4-ing-close]').forEach(function (b) { b.addEventListener('click', closeIng); });
    }

    render();
    var v0 = currentVariant();
    syncCompSlots(v0);
    if (v0 && v0.media && CFG.explicitVariantId) goToMedia(v0.media);
    root.setAttribute('data-bbv4-ready', '1');
  }

  function boot() { document.querySelectorAll('[data-bbv4-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
